export default __webpack_public_path__ + "static/media/features5.b9c852aa.svg";